import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";


const WhatsAppQR = Loadable(
	lazy(() =>
		import("./WhatsAppQR").then(({ WhatsAppQR }) => ({
			default: WhatsAppQR,
		}))
	)
);

export const whatsAppQRRoutes = [
    {
        path: REACT_APP_NAV_ROUTES.OrganizationSettings.WhatsAppQR,
        exact: true,
        element: (
            <AuthorizedRoute moduleIds={[ALLOWED_MODULES.WHATSAPP_QR]}>
                <WhatsAppQR />
            </AuthorizedRoute>
        ),
    },
   
];
